// turning ai2html's output into a module allows
// webpack to apply hot module replacement.
// we obviously want to bake it into the html in production
// that's why we're conditionally requiring it

import { Child } from 'pym.js';
// import ai2html from './ai2html-graphic.html';
import meta from './data/meta.json';
import Zion from './utils/Zion';

// styles
import './styles/index.scss';
import './styles/graphic.scss';

import us from './data/map-data.json';
import dummyData from './data/dummyData.json';
import textData from './data/data.json';

import * as d3 from 'd3';
import * as topojson from 'topojson';


const pkg = require('../package.json');

const ai2html = null;

if (process.env.NODE_ENV === 'development') {
  // turning ai2html's output into a module allows
  // webpack to apply hot module replacement.
  // we obviously want to bake it into the html in production
  // that's why we're conditionally requiring it
  // ai2html = require('./ai2html-graphic.html');
}

// eslint-disable-next-line  no-use-before-define
window.pymChild = new Child({ renderCallback: draw, id: pkg.name });

console.clear();

window.onload = () => {
  // necessary evil for right now

  // if (process.env.NODE_ENV === 'development') {
  //   Object.keys(meta).forEach((id) => {
  //     const node = document.querySelector(`.${id}`);

  //     if (node) {
  //       node.innerHTML = meta[id];
  //     }
  //   });
  // }

  const { pymChild } = window;
  pymChild.sendHeight();

  // If embedded, send Zion page view event
  if (window.pymChild.parentUrl) {
    const zion = new Zion(pkg.name, pymChild.parentUrl.split('?')[0]);
  }
};


function draw() {
  if (process.env.NODE_ENV === 'development') {
    // the code below applies the ai2html
    // during development mode.

    // const figure = document.querySelector('#ai2html-graphic');
    // figure.innerHTML = ai2html;

    // If you want to write code for this graphic,
    // move this stuff outside the if block that it's in.
  }
}

// ########
// INTERACTIVE CODE STARTS HERE
// ########


// Adding a few useful dictionaries
// I added some custom handling for the two Nebraska measures
const us_state_to_abbrev = {
  Alabama: 'AL',
  Alaska: 'AK',
  Arizona: 'AZ',
  Arkansas: 'AR',
  California: 'CA',
  Colorado: 'CO',
  Connecticut: 'CT',
  Delaware: 'DE',
  Florida: 'FL',
  Georgia: 'GA',
  Hawaii: 'HI',
  Idaho: 'ID',
  Illinois: 'IL',
  Indiana: 'IN',
  Iowa: 'IA',
  Kansas: 'KS',
  Kentucky: 'KY',
  Louisiana: 'LA',
  Maine: 'ME',
  Maryland: 'MD',
  Massachusetts: 'MA',
  Michigan: 'MI',
  Minnesota: 'MN',
  Mississippi: 'MS',
  Missouri: 'MO',
  Montana: 'MT',
  Nebraska: 'NE',
  'Nebraska-1': 'NE-1',
  'Nebraska-2': 'NE-2',
  Nevada: 'NV',
  'New Hampshire': 'NH',
  'New Jersey': 'NJ',
  'New Mexico': 'NM',
  'New York': 'NY',
  'North Carolina': 'NC',
  'North Dakota': 'ND',
  Ohio: 'OH',
  Oklahoma: 'OK',
  Oregon: 'OR',
  Pennsylvania: 'PA',
  'Rhode Island': 'RI',
  'South Carolina': 'SC',
  'South Dakota': 'SD',
  Tennessee: 'TN',
  Texas: 'TX',
  Utah: 'UT',
  Vermont: 'VT',
  Virginia: 'VA',
  Washington: 'WA',
  'West Virginia': 'WV',
  Wisconsin: 'WI',
  Wyoming: 'WY',
  'District of Columbia': 'DC',
  'American Samoa': 'AS',
  Guam: 'GU',
  'Northern Mariana Islands': 'MP',
  'Puerto Rico': 'PR',
  'United States Minor Outlying Islands': 'UM',
  'Virgin Islands, U.S.': 'VI',
};

// States of interest
const states = ['Missouri', 'South Dakota', 'Arizona', 'Florida', 'Nebraska', 'Colorado', 'New York', 'Maryland', 'Montana', 'Nevada'];

// AP labels for map
const statesAP = {
  Missouri: 'Misso.', 'South Dakota': 'Dak. del S.', Arizona: 'Ariz.', Florida: 'Flo.', Nebraska: 'Nebr.', Colorado: 'Col.', Maryland: 'Mary.', 'New York': 'NY', Montana: 'Mont.', Nevada: 'Nev.',
};

// Ballot measure data feeds
const state_data = ['I1G-AZ', 'I1G-CO', 'I1G-FL', 'I1G-MD', 'I1G-MO', 'I1G-MT', 'I1G-NE', 'I2G-NE', 'I1G-NV', 'I1G-NY', 'I1G-SD'];

// Organizing feeds by category
const bm_data = [{
  category: 'expand',
  states: ['AZ-I1', 'FL-I1', 'MO-I1', 'SD-I1'],
},
{
  category: 'protect-1',
  states: ['CO-I1', 'MD-I1', 'MT-I1'],
},
{
  category: 'protect-2',
  states: ['NV-I1', 'NY-I1'],
},
{
  category: 'duel',
  states: ['NE-I1', 'NE-I2'],
},
];

// Vote thresholds by state
const vote_thresholds = {
  AZ: 50,
  CO: 55,
  FL: 60,
  MD: 50,
  MO: 50,
  MT: 50,
  NE: 50,
  NV: 50,
  NY: 50,
  SD: 50,
};

// helper function
function formatPercentage(str) {
  // Convert string to a number
  const num = parseFloat(str);

  // Check if the decimal part is 0, and format accordingly
  return num % 1 === 0 ? `${num.toFixed(0)}%` : `${num.toFixed(1)}%`;
}

function formatNumber(num) {
  if (num >= 1000000) {
    return `${(num / 1000000).toFixed(1).replace(/\.0$/, '')}M`;
  } if (num >= 1000) {
    return `${(num / 1000).toFixed(0).replace(/\.0$/, '')}K`;
  }
  return num.toString();
}

// Create a variable to store data feeds data
const all_data = {};

// Pull data for each state
const promises = state_data.map(state => d3.json(`https://politics.api.cnn.io/results/race/2024-${state}.json`).then((result) => {
  all_data[`${result.stateAbbreviation}-${result.raceTypeCode}`] = result;
}));


// Wait for all the data feed pulls to resolve
Promise.all(promises).then(() => {
  // COUNT WINNERS FOR HEADLINE
  function countWinners(data) {
    let winnerCount = 0;
    let nebraskaCount = 0;

    for (const raceKey in data) {
      const race = data[raceKey];
      const { candidates } = race;

      candidates.forEach((candidate) => {
        if ((candidate.partyName === 'Yes') | (candidate.partyName === 'For')) {
          if ((candidate.winner === true)) {
            if ((race.stateName === 'Nebraska')) {
              nebraskaCount++;
              if (nebraskaCount == 2) {
                winnerCount -= 1;
              }
            }

            winnerCount++;
          }
        }
      });
    }

    return winnerCount;
  }

  // ##########
  // MAP
  // ##########

  // all_data = dummyData;

  // Dimensions for the map container
  let width;
  let height;

  if (window.innerWidth < 450) {
    width = 800;
    height = 600;
  } else {
    width = 960;
    height = 600;
  }

  // Set up the projection - Albers USA projection
  const projection = d3.geoAlbersUsa()
    .scale(1000) // Initial scale
    .translate([width / 2, height / 2]); // Center the map

  // Create a path generator with the projection
  const path = d3.geoPath()
    .projection(projection);

  // Create an SVG container and set up the viewBox for responsiveness
  // This will adjust to the width and height of the viewbox but keep the aspect ratio defined by the width and height above
  const svg = d3.select('#map')
    .append('svg')
    .attr('viewBox', `0 0 ${width} ${height}`)
    .attr('preserveAspectRatio', 'xMidYMid meet') // Maintain aspect ratio
    .style('width', '100%') // Set SVG to scale with the container width
    .style('height', 'auto'); // Height adjusts automatically based on width

  // Define a diagonal hatch pattern
  svg.append('defs')
    .append('pattern')
    .attr('id', 'diagonalHatch') // Give the pattern an ID
    // .attr('width', 10) // Width of each pattern tile
    // .attr('height', 10) // Height of each pattern tile
    .attr('patternUnits', 'userSpaceOnUse')
    .attr('patternTransform', 'rotate(45)') // Rotate for diagonal lines
    .append('line')
    .attr('class', 'hatchLine')
    .attr('x1', 0)
    .attr('y1', 0)
    .attr('x2', 0)
    // .attr('y2', 10)
    .attr('stroke', '#333') // Line color
    .attr('stroke-width', 1); // Line thickness


  if (window.innerWidth < 450) {
    d3.select('#diagonalHatch')
      .attr('width', 12) // Width of each pattern tile
      .attr('height', 12); // Height of each pattern tile
    d3.select('.hatchLine')
      .attr('y2', 12);
  } else {
    d3.select('#diagonalHatch')
      .attr('width', 6) // Width of each pattern tile
      .attr('height', 6); // Height of each pattern tile

    d3.select('.hatchLine')
      .attr('y2', 6);
  }

  // Bind the state topojson data and create one path per feature
  svg.append('g')
    .selectAll('path')
    .data(topojson.feature(us, us.objects.states).features)
    .enter()
    .append('path')
    .attr('class', d => `state-poly ${us_state_to_abbrev[d.properties.name]}`) // add class based on state abbreviation
    .attr('d', path); // Use the path generator to create SVG paths

  // text labels
  svg.append('g')
    .selectAll('text')
    .data(topojson.feature(us, us.objects.states).features)
    .enter()
    .append('text')
    .attr('transform', d => `translate(${path.centroid(d)})`) // Position labels at the centroid of each state
    .text(d => d.properties.name) // Use the "name" property for the label
    .text((d) => {
      const { name } = d.properties;
      if (states.includes(name)) {
        return statesAP[name];
      }
    })
    .attr('text-anchor', 'middle')
    .attr('dy', '.35em') // Adjust text vertically
    .attr('class', d => `text-halo ${d.properties.name.replace(/\s+/g, '-').toLowerCase()}`)
    .style('font-size', '12px');

  // text halo
  svg.append('g')
    .selectAll('text')
    .data(topojson.feature(us, us.objects.states).features)
    .enter()
    .append('text')
    .attr('transform', d => `translate(${path.centroid(d)})`) // Position labels at the centroid of each state
    .text((d) => {
      const { name } = d.properties;
      if (states.includes(name)) {
        return statesAP[name];
      }
    })
    .attr('text-anchor', 'middle')
    .attr('dy', '.35em') // Adjust text vertically
    .attr('class', d => `state-label ${d.properties.name.replace(/\s+/g, '-').toLowerCase()}`)
    .style('font-size', '12px');

  // Viewboxes do terrible things to text
  // Some hacky code to tie text size to screen size
  const factor = 12;
  // Add responsive behavior on window resize
  window.addEventListener('resize', () => {
    const targetWidth = svg.node().getBoundingClientRect().width;
    const newHeight = targetWidth * height / width;
    svg.attr('height', newHeight);

    // Adjust font size based on width (this ensures text scales)
    const newFontSize = 18 * (600 / parseInt(targetWidth)); // Adjust the factor as needed
    svg.selectAll('.state-label').style('font-size', `${newFontSize}px`);
    svg.selectAll('.text-halo').style('font-size', `${newFontSize}px`);

    if (window.innerWidth < 450) {
      d3.select('#diagonalHatch')
        .attr('width', 12) // Width of each pattern tile
        .attr('height', 12); // Height of each pattern tile
      d3.select('.hatchLine')
        .attr('y2', 12);
    } else {
      d3.select('#diagonalHatch')
        .attr('width', 6) // Width of each pattern tile
        .attr('height', 6); // Height of each pattern tile

      d3.select('.hatchLine')
        .attr('y2', 6);
    }
  });

  // ##########
  // CARDS
  // ##########

  const yesTally = 0;

  // For each category grouping, generate card data
  bm_data.forEach((card) => {
    // For each card, generate race data
    card.states.forEach((code) => {
      const datum = all_data[code];

      // ###########
      // RACE FLAG
      // ###########

      // This logic creates a flag for each ballot measure that signifies whether:
      // - polls not closed OR
      // - yes or no vote is leading OR
      // - yes or no vote has won
      // Note: this flag is what drives the map colors

      // Set overall race flag
      function setRaceFlag(raceData) {
        const { candidates, percentReporting } = raceData;

        // Check if percentReporting is 0
        if (percentReporting === 0) {
          raceData.flag = 'noData';
          return raceData;
        }

        // Check if any candidate has winner set to true
        const winningCandidate = candidates.find(candidate => candidate.winner);

        if (winningCandidate) {
          // If there's a winner, set flag to lowercase partyName + "winner"
          raceData.flag = `${winningCandidate.partyName.toLowerCase()}Winner`;
        } else {
          // If no winner, determine which candidate has the higher voteNum
          const leadingCandidate = candidates.reduce((lead, candidate) => (candidate.voteNum > lead.voteNum ? candidate : lead));
          // Set flag to lowercase partyName + "lead"
          raceData.flag = `${leadingCandidate.partyName.toLowerCase()}Lead`;
        }

        return raceData;
      }

      setRaceFlag(datum);

      // ###########
      // CANDIDATE FLAG
      // ###########

      // This logic creates a voteShare property for each ballot measure's yes/no candidate object that signifies whether:
      // - yes or no vote is leading OR
      // - yes or no vote has won
      // Note: this property drives the bar colors

      function setVoteShare(candidates) {
        // Check if either candidate has "winner" set to true
        if (candidates[0].winner) {
          candidates[0].voteShare = 'winner';
          candidates[1].voteShare = 'notWinner';
        } else if (candidates[1].winner) {
          candidates[1].voteShare = 'winner';
          candidates[0].voteShare = 'notWinner';
        } else {
          // If neither is a winner, compare "voteNum" and assign "first" or "second"
          if (candidates[0].voteNum > candidates[1].voteNum) {
            candidates[0].voteShare = 'lead';
            candidates[1].voteShare = 'notLead';
          } else {
            candidates[0].voteShare = 'notLead';
            candidates[1].voteShare = 'lead';
          }
        }

        return candidates;
      }

      setVoteShare(datum.candidates);


      // For each race, creating variables to store "Yes" vote data and "No" vote data
      // This is necessary because sometimes datum.candidates[0] is the yes data and sometimes it's the no data (I have observed in the test data that the order can change)
      let yesData;
      let noData;

      function elexData(partyName) {
        if (partyName == 'Yes') {
          yesData = datum.candidates.find(obj => obj.partyName === 'Yes');
        } else if (partyName == 'For') {
          yesData = datum.candidates.find(obj => obj.partyName === 'For');
        } else if (partyName == 'No') {
          noData = datum.candidates.find(obj => obj.partyName === 'No');
        } else if (partyName == 'Against') {
          noData = datum.candidates.find(obj => obj.partyName === 'Against');
        }
      }
      elexData(datum.candidates[0].partyName);
      elexData(datum.candidates[1].partyName);


      // Use our new flags to set classes to color the map states
      // Special handling for if it's a Nebraska ballot measure to color one half of the state
      if (datum.stateAbbreviation == 'NE') {
        if (datum.contestType == 'I1G') {
          d3.selectAll('path.NE-1')
            .classed('active', true)
            .classed(datum.flag, true);
        } else if (datum.contestType == 'I2G') {
          d3.selectAll('path.NE-2')
            .classed('active', true)
            .classed(datum.flag, true);
        }
      } else {
        d3.selectAll(`path.${datum.stateAbbreviation}`)
          .classed('active', true)
          .classed(datum.flag, true);
      }

      // Code for timestamp
      const optionsTime = {
        timeZone: 'America/New_York',
        hour: 'numeric', // Removes leading zero
        minute: '2-digit',
        hour12: true, // 12-hour format with AM/PM
      };

      const optionsDate = {
        timeZone: 'America/New_York',
        year: 'numeric',
        month: 'long', // Abbreviated month (e.g., Nov)
        day: 'numeric',
      };

      const currentTime = new Date();
      const formattedTime = currentTime.toLocaleString('en-US', optionsTime).replace('AM', 'a.m.').replace('PM', 'p.m.');
      const formattedDate = currentTime.toLocaleString('es-MX', optionsDate);

      // UPDATE COPY
      if (countWinners(all_data) == 1) {
        d3.select('.headline').html(`<span id='span-num'>${countWinners(all_data)}</span> estado han aprobado medidas que protegen o amplían los derechos al aborto`);
      } else {
        d3.select('.headline').html('Siguiendo las medidas electorales que protegen o amplían los derechos al aborto en EE.UU.');
      }

      // UPDATE COPY
      // if (countWinners(all_data) == 1) {
      //   d3.select('.headline').html(`<span id='span-num'>${countWinners(all_data)}</span> estado han aprobado medidas que protegen o amplían los derechos al aborto`);
      // } else {
      //   d3.select('.headline').html(`<span id='span-num'>${countWinners(all_data)}</span> estados han aprobado medidas que protegen o amplían los derechos al aborto`);
      // }

      // COPY FOR ELECTION NIGHT
      // if (countWinners(all_data) == 1) {
      //   d3.select('.headline').html(`CNN proyecta que los votantes de <span id='span-num'>${countWinners(all_data)}</span> estado han aprobado medidas que protegen o amplían los derechos al aborto hasta ahora`);
      // } else {
      //   d3.select('.headline').html(`CNN proyecta que los votantes de <span id='span-num'>${countWinners(all_data)}</span> estados han aprobado medidas que protegen o amplían los derechos al aborto hasta ahora`);
      // }

      d3.select('.subhed-custom').html(`${textData[0].dek}`);
      d3.select('#note').html(`${textData[0].note}`);
      d3.select('#timestamp').html(`Nota: Última actualización: ${formattedTime}, hora de Miami, el ${formattedDate}.`);

      d3.select('#source').html(`Fuentes: ${textData[0].source}`);

      // #######
      // CREATE STATE BAR DATA
      // #######

      const state = d3.select(`#${card.category}`)
        .append('div')
        .attr('class', `state-container ${datum.stateAbbreviation}-${datum.raceType}`);

      // Add state name
      const state_name = state.append('div')
        .attr('class', 'state-name')
        .html((d) => {
          if ((datum.stateName == 'Nebraska') & (datum.raceType == 'I1')) {
            return `${datum.stateName}**`;
          } if (datum.stateName == 'Nevada') {
            return `${datum.stateName}*`;
          }
          return datum.stateName;
        });

      // Add measure name
      state_name
        .append('span')
        .attr('class', 'prop-title')
        .html(`(${datum.raceTitle})`)
        .html((d) => {
          if ((datum.stateName == 'Nebraska') & (datum.raceType == 'I1')) {
            return `(${datum.raceTitle}): <br>Legalizar hasta la viabilidad`;
          }
          if ((datum.stateName == 'Nebraska') & (datum.raceType == 'I2')) {
            return `(${datum.raceTitle}): <br>Consagrar la prohibición actual de 12 semanas`;
          }
          return `(${datum.raceTitle})`;
        });

      // ########
      // VOTE PROGRESS BARS
      // ########

      // YES BARS
      const yesGroup = state.append('div')
        .attr('class', 'data');

      // yesGroup
      //   .append('div')
      //   .attr('class', `vote-name-label ${yesData.partyName.toLowerCase()}`)
      //   .html(`${yesData.partyName}`);

      const yesBar = yesGroup
        .append('div')
        .attr('class', 'bar');

      // if ((yesData.votePercentStr != 0) & (yesData.voteNum > 50000)) {
      //   yesBar
      //     .append('div')
      //     .html(`${formatNumber(yesData.voteNum)}`)
      //     .style('width', `${yesData.votePercentStr}%`)
      //     .attr('class', 'vote-total-label')
      //     .style('display', 'block')
      //     .style('animation', 'visible 5s');
      // }

      if (yesData.voteShare == 'winner') {
        yesBar
          .append('div')
          .attr('class', 'vote-name-label')
          .style('color', 'white')
          .style('font-weight', 700)
          .html(`${yesData.partyName}`)
          .append('span')
          .attr('class', `checkmark ${yesData.partyName.toLowerCase()}`)
          .html('<svg width="12" height="12" aria-label="Race called" role="img" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" data-icon="checkmark"><g id="table-checkmark-icon" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="table-icon-/-checkmark--/-dem"><path d="M0,8 C0,12.4181333 3.58186667,16 8,16 C12.4181333,16 16,12.4181333 16,8 C16,3.5816 12.4181333,0 8,0 C3.58186667,0 0,3.5816 0,8 Z" id="table-path-1-copy" fill="#FFF"></path><path d="M13.5967059,5.98070588 L8.248,11.3294118 L7.24329412,12.3341176 C7.10541176,12.472 6.93788235,12.5407059 6.74117647,12.5407059 C6.544,12.5407059 6.37647059,12.472 6.23858824,12.3341176 L5.23435294,11.3294118 L2.55952941,8.65505882 C2.42164706,8.51717647 2.35294118,8.34964706 2.35294118,8.15294118 C2.35294118,7.95576471 2.42164706,7.78823529 2.55952941,7.65035294 L3.56470588,6.64564706 C3.70258824,6.50823529 3.86964706,6.43905882 4.06682353,6.43905882 C4.264,6.43905882 4.43105882,6.50823529 4.56894118,6.64564706 L6.74117647,8.82494118 L11.5872941,3.97129412 C11.7247059,3.83341176 11.8922353,3.76470588 12.0894118,3.76470588 C12.2865882,3.76470588 12.4541176,3.83341176 12.592,3.97129412 L13.5967059,4.976 C13.7345882,5.11435294 13.8032941,5.28188235 13.8032941,5.47858824 C13.8032941,5.67529412 13.7345882,5.84282353 13.5967059,5.98070588 Z" id="table-Fill-1" fill="#077a63"></path></g></g></svg>');
      } else {
        yesBar
          .append('div')
          .attr('class', 'vote-name-label')
          .html(`${yesData.partyName}`);
      }

      const yesBarData = yesBar.append('div')
        .attr('class', 'totals-container yes-bar');

      yesBarData.append('div')
        .attr('class', 'data-total');

      yesBarData.append('div')
        .attr('class', `vote-total ${yesData.voteShare}`)
        .style('width', 0)
        .transition()
        .duration(800)
        .style('width', `${yesData.votePercentStr}%`);

      yesBar
        .append('div')
        .attr('class', 'vote-percent-label')
        .html(`${formatPercentage(yesData.votePercentStr)}`);


      // NO BARS

      const noGroup = state.append('div')
        .attr('class', 'data');

      // noGroup
      //   .append('div')
      //   .attr('class', 'vote-name-label')
      //   .html(`${formatNumber(noData.partyName)}`);

      const noBar = noGroup
        .append('div')
        .attr('class', 'bar');

      // if ((noData.votePercentStr != 0) & (noData.voteNum > 50000)) {
      //   noBar
      //     .append('div')
      //     .html(`${formatNumber(noData.voteNum)}`)
      //     .style('width', `${noData.votePercentStr}%`)
      //     .attr('class', 'vote-total-label')
      //     .style('display', 'block')
      //     .style('animation', 'visible 5s');
      // }

      // noBar
      //   .append('div')
      //   .attr('class', 'vote-total-label')
      //   .html(`${formatNumber(noData.voteNum)}`);

      if (noData.voteShare == 'winner') {
        noBar
          .append('div')
          .attr('class', 'vote-name-label')
          .style('color', 'white')
          .style('font-weight', 700)
          .html(`${noData.partyName}`)
          .append('span')
          .attr('class', `checkmark ${noData.partyName.toLowerCase()}`)
          .html('<svg width="12" height="12" aria-label="Race called" role="img" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" data-icon="checkmark"><g id="table-checkmark-icon" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="table-icon-/-checkmark--/-dem"><path d="M0,8 C0,12.4181333 3.58186667,16 8,16 C12.4181333,16 16,12.4181333 16,8 C16,3.5816 12.4181333,0 8,0 C3.58186667,0 0,3.5816 0,8 Z" id="table-path-1-copy" fill="#FFF"></path><path d="M13.5967059,5.98070588 L8.248,11.3294118 L7.24329412,12.3341176 C7.10541176,12.472 6.93788235,12.5407059 6.74117647,12.5407059 C6.544,12.5407059 6.37647059,12.472 6.23858824,12.3341176 L5.23435294,11.3294118 L2.55952941,8.65505882 C2.42164706,8.51717647 2.35294118,8.34964706 2.35294118,8.15294118 C2.35294118,7.95576471 2.42164706,7.78823529 2.55952941,7.65035294 L3.56470588,6.64564706 C3.70258824,6.50823529 3.86964706,6.43905882 4.06682353,6.43905882 C4.264,6.43905882 4.43105882,6.50823529 4.56894118,6.64564706 L6.74117647,8.82494118 L11.5872941,3.97129412 C11.7247059,3.83341176 11.8922353,3.76470588 12.0894118,3.76470588 C12.2865882,3.76470588 12.4541176,3.83341176 12.592,3.97129412 L13.5967059,4.976 C13.7345882,5.11435294 13.8032941,5.28188235 13.8032941,5.47858824 C13.8032941,5.67529412 13.7345882,5.84282353 13.5967059,5.98070588 Z" id="table-Fill-1" fill="#522349"></path></g></g></svg>');
      } else {
        noBar
          .append('div')
          .attr('class', 'vote-name-label')
          .html(`${noData.partyName}`);
      }

      const noBarData = noBar.append('div')
        .attr('class', 'totals-container no-bar');

      noBarData.append('div')
        .attr('class', 'data-total');

      noBarData.append('div')
        .attr('class', `vote-total ${noData.voteShare}`)
        .style('width', 0)
        .transition()
        .duration(800)
        .style('width', `${noData.votePercentStr}%`);

      noBar
        .append('div')
        .attr('class', 'vote-percent-label')
        .html(`${formatPercentage(noData.votePercentStr)}`);

      // VOTE THRESHOLD LINE
      const line = yesBar.append('div')
        .attr('class', 'line-container')
        .style('left', `${vote_thresholds[datum.stateAbbreviation]}%`);

      // Create line to show yes vote threshold
      line.append('div')
        .attr('class', 'vertical-line');

      const bar_label = line.append('div')
        .attr('class', 'line-label');

      // Custom line labels for first states
      if ((datum.stateAbbreviation == 'AZ') | (datum.stateAbbreviation == 'CO')) {
        bar_label.text(`${vote_thresholds[datum.stateAbbreviation]}% sí para aprobarse`);
      } else {
        bar_label.text(`${vote_thresholds[datum.stateAbbreviation]}%`);
      }

      // VOTE REPORTING

      const resultsText = state.append('div').attr('class', 'results-text');

      if (datum.stateAbbreviation == 'NE') {
        if (datum.contestType == 'I1G') {
          resultsText
            .append('a')
            .attr('class', 'county-results')
            .attr('target', '_blank')
            .attr('href', `https://www.cnn.com/election/2024/results/${datum.stateName.replace(/\s+/g, '-').toLowerCase()}/issue-1`)
            .html('Resultados por condado >');
        } else if (datum.contestType == 'I2G') {
          resultsText
            .append('a')
            .attr('class', 'county-results')
            .attr('target', '_blank')
            .attr('href', `https://www.cnn.com/election/2024/results/${datum.stateName.replace(/\s+/g, '-').toLowerCase()}/issue-2`)
            .html('Resultados por condado >');
        }
      } else {
        resultsText
          .append('a')
          .attr('class', 'county-results')
          .attr('target', '_blank')
          .attr('href', `https://www.cnn.com/election/2024/results/${datum.stateName.replace(/\s+/g, '-').toLowerCase()}/issue-1`)
          .html('Resultados por condado >');
      }

      resultsText
        .append('p')
        .attr('class', 'percent-reporting')
        .html(`Estimado ${datum.percentReporting}% de votos`);
    });
  });


  pymChild.sendHeight();
});

pymChild.sendHeight();
